import { AaGetcaptchaResp } from 'app/bff/models/aa/aaGetcaptcha';
import { AaCaptchaVerifyReq } from 'app/bff/models/aa/aaCaptchaVerify';
import { AaOtpSendcodeReq } from 'app/bff/models/aa/aaOtpSendcode';
import { MbSigninResp } from 'app/bff/models/mb/mbSignin';
import { AaOtpVerifyReq, AaOtpVerifyResp } from 'app/bff/models/aa/aaOtpVerify';
import { MbUpdateinfoReq } from 'app/bff/models/mb/mbUpdateinfo';
import { ROUTES } from 'app/core/router/paths';
import { ProcessStepCodesEnum } from 'app/features/Member/Forget/types';
import { FormValues as AuthFormValues } from 'app/features/Member/Forget/Auth/types';
import { MEMBER_FORGET__RESEND_OTP_DONE, MEMBER_FORGET__RESEND_OTP, ForgetState, ForgetActions, MEMBER_FORGET__SET_ACCESSIBLE_STEP, MEMBER_FORGET__FETCH_CAPTCHA, MEMBER_FORGET__FETCH_CAPTCHA_DONE, MEMBER_FORGET__CHECK_CAPTCHA, MEMBER_FORGET__SAVE_AUTH_PAGE_DATA, MEMBER_FORGET__SEND_OTP, MEMBER_FORGET__SEND_OTP_DONE, MEMBER_FORGET__AUTH_OTP, MEMBER_FORGET__SAVE_TEMPORARY_AUTHORIZATION, MEMBER_FORGET__SETUP_NEW_PASS_PHRASE, MEMBER_FORGET__UPDATE_CACHE, MEMBER_FORGET__RESET_CACHE } from './types';

/**
 * @description 設置可訪問步驟 (Action)
 * @param step 當前步驟
 */
export const setAccessibleStepAction = (step: ProcessStepCodesEnum): ForgetActions => ({
  type: MEMBER_FORGET__SET_ACCESSIBLE_STEP,
  payload: { step }
});

/**
 * @description 取得圖形驗證碼 (Action)
 */
export const fetchCaptchaAction = (): ForgetActions => ({
  type: MEMBER_FORGET__FETCH_CAPTCHA
});

/**
 * @description 取得圖形驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const fetchCaptchaDoneAction = (response: AaGetcaptchaResp): ForgetActions => ({
  type: MEMBER_FORGET__FETCH_CAPTCHA_DONE,
  payload: { response }
});

/**
 * @description 驗證圖形驗證碼 (Action)
 * @param checkCaptchaArgs 驗證圖形驗證碼，請求所需的參數
 * @param sendOTPArgs 發送 OTP 驗證碼，請求所需的參數
 * @param data 頁面資料
 */
export const checkCaptchaAction = (checkCaptchaArgs: AaCaptchaVerifyReq, sendOTPArgs: AaOtpSendcodeReq, data: AuthFormValues): ForgetActions => ({
  type: MEMBER_FORGET__CHECK_CAPTCHA,
  payload: { checkCaptchaArgs, sendOTPArgs, data }
});

/**
 * @description 緩存「輸入基本資料」(Step-1-1) 頁面資料 (Action)
 * @param data 頁面資料
 */
export const saveAuthPageDataAction = (data: AuthFormValues): ForgetActions => ({
  type: MEMBER_FORGET__SAVE_AUTH_PAGE_DATA,
  payload: { data }
});

/**
 * @description 發送 OTP 驗證碼 (Action)
 * @param args 請求所需的參數
 * @param redirectRoute 轉導路由
 */
export const sendOTPAction = (args: AaOtpSendcodeReq, redirectRoute?: ROUTES): ForgetActions => ({
  type: MEMBER_FORGET__SEND_OTP,
  payload: { args, redirectRoute }
});

/**
 * @description 發送 OTP 驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const sendOTPDoneAction = (response: MbSigninResp): ForgetActions => ({
  type: MEMBER_FORGET__SEND_OTP_DONE,
  payload: { response }
});

/**
 * @description 重新發送 OTP 驗證碼 (Action)
 */
export const resendOTPAction = (): ForgetActions => ({
  type: MEMBER_FORGET__RESEND_OTP,
  payload: {}
});

/**
 * @description 重新發送 OTP 驗證碼 完成 (Action)
 */
export const resendOTPDoneAction = (response: MbSigninResp): ForgetActions => ({
  type: MEMBER_FORGET__RESEND_OTP_DONE,
  payload: { response }
});

/**
 * @description 驗證 OTP 驗證碼 (Action)
 * @param args 請求所需的參數
 */
export const authOTPAction = (args: AaOtpVerifyReq): ForgetActions => ({
  type: MEMBER_FORGET__AUTH_OTP,
  payload: { args }
});

/**
 * @description 緩存暫時性「會員主檔」和「Access Token」 (Action)
 * @param authorization 會員登入授權
 */
export const saveTemporaryAuthorizationAction = (authorization: AaOtpVerifyResp): ForgetActions => ({
  type: MEMBER_FORGET__SAVE_TEMPORARY_AUTHORIZATION,
  payload: { authorization }
});

/**
 * @description 設置會員新密碼 (Action)
 * @param args 請求所需的參數
 */
export const setupNewPassPhraseAction = (args: MbUpdateinfoReq): ForgetActions => ({
  type: MEMBER_FORGET__SETUP_NEW_PASS_PHRASE,
  payload: { args }
});

/**
 * @description 更新資料緩存 (Action)
 * @param cache 緩存資料
 */
export const updateCacheAction = (cache: ForgetState): ForgetActions => ({
  type: MEMBER_FORGET__UPDATE_CACHE,
  payload: { cache }
});

/**
 * @description 重置資料緩存 (Action)
 */
export const resetCacheAction = (): ForgetActions => ({
  type: MEMBER_FORGET__RESET_CACHE
});
